import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import LoginPage from './LoginPage';
import HostLogin from './HostLogin';
import MyPage from './MyPage.js';
import CorporateMypage from './CorporateMypage';
import api from './api.js';
import FormRequire from './FormRequire.js';
import Comp3Sub from './Comp3Sub.js';
import Comp4Sub from './Comp4Sub.js';
import FormElectricity from './FormElectricity.js';
import Comp7Sub from './Comp7Sub.js';
import Comp8Sub from './Comp8Sub.js';
import Comp9Sub from './Comp9Sub.js';
import Comp10Sub from './Comp10Sub.js';
import Comp11Sub from './Comp11Sub.js';
import Comp12Sub from './Comp12Sub.js';
import Comp13Sub from './Comp13Sub.js';
import CoExhibitMypage from './CoExhibitMypage.js';
import MypageInfo from './MypageInfo.js';
import MailFormPage from './MailForm.js';
import HostMypage from './HostMypage.js';
import CorporateMypageInfo from './CorporateMypageInfo.js';
import CorporateInfo from './CorporateInfo.js';
import ExhibitorInfo from './ExhibitorInfo.js';
import CreateMail from './CreateMail.js';
import CreateNotice from './CreateNotice.js';
import NoticeDetail from './NoticeDetail.js';
import FormHistoryTable from './FormHistory.js';
import ResetPassword from './ResetPassword.js';
import { NavigationHistoryProvider } from './common/navigationHistory.js';
import Comp10_2Sub from './Comp10_2Sub.js';
import Comp11_2Sub from './Comp11_2Sub.js';
import Comp5Sub from './Comp5Sub.js';
import Comp6Sub from './Comp6Sub.js';
import NavigationTracker from './common/NavigationTracker.js';
import { AuthProvider } from './common/AuthContext.js';
import ProtectedRoute from './common/ProtectedRoute.js';

function App() {
  const protect = (element, allowedRoles) => <ProtectedRoute allowedRoles={allowedRoles}>{element}</ProtectedRoute>;
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [exhibitorId, setExhibitorId] = useState(null);
  const location = useLocation();

  useEffect(() => {
      const userData = localStorage.getItem("user");
      if (userData) {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);

        if (parsedUser?.role === "exhibitor") {
          if (parsedUser.exhibitor_id) {
            setExhibitorId(parsedUser.exhibitor_id);
          } else {
            console.warn("出展者ユーザーの exhibitor_id が見つかりません");
            setExhibitorId(null);
          }
        } else {
          // 主催者・協力会社には exhibitor_id がないため、警告対象にしない。
          setExhibitorId(null);
        }
      } else {
        setUser(null);
        setExhibitorId(null);
      }
  }, [location]);

  return (
    <AuthProvider>
    <NavigationHistoryProvider>
      <NavigationTracker />
      <Routes>
        <Route
          path="/"
          element={
            <LoginPage
              setIsAuthenticated={setIsAuthenticated}
              setUser={setUser}
            />
          }
        />
        <Route
          path="/login/host"
          element={<HostLogin setIsAuthenticated={setIsAuthenticated} />}
        />
        <Route path="/mypage/:exhibitorId" element={protect(<MyPage />, ["exhibitor"])} />
        <Route path="/co-exhibit-mypage/:exhibitorId" element={protect(<CoExhibitMypage />, ["exhibitor"])} />
        <Route path="/corporate-mypage/:representativeId" element={protect(<CorporateMypage />, ["corporate"])} />
        <Route path="/form-require" element={protect(<FormRequire exhibitorId={exhibitorId} />, ["host","exhibitor"])} />
        <Route path="/form-o-3" element={protect(<Comp3Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-o-4" element={protect(<Comp4Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-elec" element={protect(<FormElectricity exhibitorId={exhibitorId} />, ["corporate","exhibitor"])} />
        <Route path="/form-o-5" element={protect(<Comp5Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-o-6" element={protect(<Comp6Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-o-7" element={protect(<Comp7Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-o-8" element={protect(<Comp8Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-o-9" element={protect(<Comp9Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-o-10" element={protect(<Comp10Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-o-10_2" element={protect(<Comp10_2Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-o-11" element={protect(<Comp11Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-o-11_2" element={protect(<Comp11_2Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-o-12" element={protect(<Comp12Sub exhibitorId={exhibitorId} />)} />
        <Route path="/form-o-13" element={protect(<Comp13Sub exhibitorId={exhibitorId} />)} />
        <Route path="/mypage-info/:exhibitorId" element={protect(<MypageInfo />, ["exhibitor"])} />
        <Route path="/mail-form/" element={protect(<MailFormPage />, ["exhibitor"])} />
        <Route path="/host-dashboard/" element={protect(<HostMypage />, ["host"])} />
        <Route path="/corporate-mypage-info/:representativeId" element={protect(<CorporateMypageInfo />, ["corporate"])} />
        <Route path="/exhibitor-info" element={protect(<ExhibitorInfo />, ["host"])} />
        <Route path="/corporate-info" element={protect(<CorporateInfo />, ["host"])} />
        <Route path="/create-mail" element={protect(<CreateMail />, ["host"])} />
        <Route path="/create-notice" element={protect(<CreateNotice />, ["host"])} />
        <Route path="/news/:noticeId" element={protect(<NoticeDetail />)} />
        <Route path="/form-history" element={protect(<FormHistoryTable />, ["host"])} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </NavigationHistoryProvider>
    </AuthProvider>
  );
}

export default App;
